import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BookCard from "../Card/BookCard";
import axios from "axios";
import FiveBundleImages from "../../assets/images/allbooks.png";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const IMAGE_BASE_URL = "https://kitehawk-api.onrender.com/image/";

export const ChooseBooks = () => {
  const [books, setBooks] = useState([]);
  const navigate = useNavigate();

  const videosources = [
    "https://player.cloudinary.com/embed/?cloud_name=dyhrd2zdv&public_id=dummy-video_a6apbm&profile=cld-default",
  ];

  useEffect(() => {
    fetchBooks();
  }, []);


  const fetchBooks = async () => {
    try {
      const token = localStorage.getItem("userToken");

      // console.log("TOKEN =>", token);
      // console.log("API URL =>", `${BASE_URL}/api/getallbooks`);

      const { data } = await axios.get(`${BASE_URL}/api/getallbooks`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      data?.data?.forEach((item, index) => {
        console.log(`BOOK ${index + 1} =>`, item);
      });

      setBooks(data?.data || []);
    } catch (error) {
      console.log("Get books error:", error?.response?.data || error.message);
    }
  };
  const austBooks = books.filter((b) => b.flag === "aust");
  const usaBooks = books.filter((b) => b.flag === "usa");

  const handleBuyBook = (url) => {
    if (!url) return;
    const finalUrl = url.startsWith("http") ? url : `https://${url}`;
    window.open(finalUrl, "_blank");
  };

  return (
    <div className="w-full px-8 sm:px-6 lg:px-10 lg:py-10 lg:space-y-6">
      <h1 className="text-center font-extrabold  text-xl lg:text-3xl  mb-3 leading-tight text-black">
        Workbook Programs
      </h1>

      <p className="text-center text-gray-600 text-sm sm:text-base md:text-lg mb-8 max-w-8xl mx-auto">
        Kitehawk offers 5 Workbook Programs which are suitable for Year or Grade
        3 and above, including adults. Each workbook represents about a year’s
        work in a normal classroom.Select the required, USA courses or the
        Australian/NZ courses
      </p>

      <h1 className="text-center font-extrabold  mb-3 text-gray-800  text-lg lg:text-2xl">
        Kitehawk Professional Development Video
      </h1>

      <p className="text-center text-gray-600 text-sm sm:text-base md:text-lg mb-8 max-w-8xl mx-auto">
        For teachers and tutors. A Professional Development video which examines
        in more depth the strategy behind the Kitehawk Program. Many Online
        activities are used, which are similar to the Workbook exercises.
      </p>

      <div className="flex justify-center gap-20 p-2  flex-col lg:flex-row lg:flex-wrap  ">
        {videosources &&
          videosources.map((source, index) => {
            return (
              <iframe
                key={index}
                src={source}
                allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
                allowfullScreen
                frameborder="0"
              ></iframe>
            );
          })}
      </div>

      <p className="text-center text-gray-600 text-sm sm:text-base md:text-lg mb-8 max-w-8xl mx-auto">
        <strong> Please Note: </strong> Ensure you are ordering Australian or
        USA Programs. Order workbooks through Amazon or through the author.{" "}
        <br></br> To order, select the Workbooks required:
      </p>
      <div className="coursesBgImage pt-10 pb-10 space-y-8">
        <h1 className="w-full text-center font-bold text-xl lg:text-2xl">
          Australia - NZ Workbooks{" "}
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 place-items-center">
          {austBooks.map((item) => (
            <BookCard
              key={item._id}
              title={item.bookname}
              // image={`${IMAGE_BASE_URL}${item.bookimage}`}
              image={item.bookimage?.startsWith("http") ? item.bookimage : `${IMAGE_BASE_URL}${item.bookimage}`}
              imageClassName="w-40 h-40 sm:w-48 sm:h-48 object-contain mx-auto"
              onBuyNow={() => handleBuyBook(item.bookurl)}
              buttontext="BUY WORKBOOKS"
              flag={item.flag}
            />
          ))}

          {/* <BookCard
            flag="aust"
            title="5 BOOKS"
            image={FiveBundleImages}
            imageClassName="w-40 h-40 sm:w-48 sm:h-48 object-contain mx-auto"
            buttontext="BUY WORKBOOKS"
          /> */}
        </div>

        <h1 className="w-full text-center font-bold text-xl lg:text-2xl">
          USA Workbooks
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 place-items-center">
          {usaBooks.map((item) => (
            <BookCard
              key={item._id}
              title={item.bookname}
              // image={`${IMAGE_BASE_URL}${item.bookimage}`}
              image={item.bookimage?.startsWith("http") ? item.bookimage : `${IMAGE_BASE_URL}${item.bookimage}`}
              imageClassName="w-40 h-40 sm:w-48 sm:h-48 object-contain mx-auto"
              onBuyNow={() => handleBuyBook(item.bookurl)}
              buttontext="BUY WORKBOOKS"
              flag={item.flag}
            />
          ))}

          {/* Last same grid me add hoga */}
          {/* <BookCard
            flag="usa"
            title="5 BOOKS"
            image={FiveBundleImages}
            imageClassName="w-40 h-40 sm:w-48 sm:h-48 object-contain mx-auto"
            buttontext="BUY WORKBOOKS"
          /> */}
        </div>
      </div>
    </div>
  );
};
